var AppointmentCommunicationChannel;
(function(AppointmentCommunicationChannel) {
    AppointmentCommunicationChannel["EMAIL"] = "EMAIL";
    AppointmentCommunicationChannel["SMS"] = "SMS";
})(AppointmentCommunicationChannel || (AppointmentCommunicationChannel = {}));

export { AppointmentCommunicationChannel };
//# sourceMappingURL=shared.js.map
